import type { ServerInfoModel } from "../../../OpenApi/api";

export interface IServerInfoStore {
    readonly serverCode: string;
	readonly machineName: string | null;
	readonly isDebug: boolean;
	readonly isLocal: boolean;
}

export class ServerInfoStore implements IServerInfoStore {
	public readonly serverCode: string;
    public readonly machineName: string | null;
	public readonly isDebug: boolean;
	public readonly isLocal: boolean;

	constructor(serverInfo: ServerInfoModel) {
        this.serverCode = serverInfo.serverCode;
		this.machineName = serverInfo.machineName;
		this.isDebug = serverInfo.isDebug;
		this.isLocal = serverInfo.isLocal;
	}
}
